import React, { Component } from "react";
import {
  Grid, Segment, Divider, List,
  Button, Modal, Icon, Image,
  Dropdown, Header, Form, Popup
} from "semantic-ui-react";
import { Network, DataSet } from "vis";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";
import C2S from "canvas2svg-visjs";

const ipRegex = new RegExp("^[0-2][0-9.]*$");

const NETWORK_ID = "network";
const ADD_DEVICE_MODAL_OK_ID = "add-device-button";
const ADD_DEVICE_MODAL_CLOSE_ID = "close-add-device-modal-button";
const ADD_IP_ID = "add-ip-id";
const EDIT_LL_DEVICE_MODAL_CLOSE_ID = "close-edit-ll-device-modal-button";
const EDIT_LL_DEVICE_MODAL_OK_ID = "edit-ll-device-button";

const OPTIC_FIBER_COLOR = "#000000";

const SCANNER_DEVICE_TYPE = "Scanner";
const DEVICE_TYPE = "Device";
const SWITCH_DEVICE_TYPE = "Switch";
const DRIVE_DEVICE_TYPE = "Drive";
const ACCESS_POINT_DEVICE_TYPE = "Access Point";

const DEFAULT_EDGE_COLOR = OPTIC_FIBER_COLOR; // ou a cor que você quer
const DEFAULT_EDGE_WIDTH = 2.0;

const GRID_SIZE = 100;

const UtilsInstance = new Utils();

// List of devices and connections with problems
// They are marked to be automatically removed from saved devices and saved connections
var devicesToDeleteFromSavedDevices;
var connectionsToDeleteFromSavedConnections;

// Vis.js Network
var nodes = new DataSet();
var edges = new DataSet();
var networkOptions = {};
var network;

// Export Image Canvas options
C2S.prototype.circle = CanvasRenderingContext2D.prototype.circle;
C2S.prototype.square = CanvasRenderingContext2D.prototype.square;
C2S.prototype.triangle = CanvasRenderingContext2D.prototype.triangle;
C2S.prototype.triangleDown = CanvasRenderingContext2D.prototype.triangleDown;
C2S.prototype.star = CanvasRenderingContext2D.prototype.star;
C2S.prototype.diamond = CanvasRenderingContext2D.prototype.diamond;
C2S.prototype.roundRect = CanvasRenderingContext2D.prototype.roundRect;
C2S.prototype.ellipse_vis = CanvasRenderingContext2D.prototype.ellipse_vis;
C2S.prototype.database = CanvasRenderingContext2D.prototype.database;
C2S.prototype.arrowEndpoint = CanvasRenderingContext2D.prototype.arrowEndpoint;
C2S.prototype.circleEndpoint = CanvasRenderingContext2D.prototype.circleEndpoint;
C2S.prototype.dashedLine = CanvasRenderingContext2D.prototype.dashedLine;

var typeOptions = [
  {
    key: SWITCH_DEVICE_TYPE,
    text: Strings.SWITCH,
    value: SWITCH_DEVICE_TYPE
  },
  {
    key: ACCESS_POINT_DEVICE_TYPE,
    text: Strings.ACCESS_POINT_NAME,
    value: ACCESS_POINT_DEVICE_TYPE
  }
];

var liveListTypeOptions = [
  {
    key: DEVICE_TYPE,
    text: Strings.DEVICE_NAME,
    value: DEVICE_TYPE
  },
  {
    key: DRIVE_DEVICE_TYPE,
    text: Strings.DRIVE,
    value: DRIVE_DEVICE_TYPE
  },
  {
    key: SWITCH_DEVICE_TYPE,
    text: Strings.SWITCH,
    value: SWITCH_DEVICE_TYPE
  },
  {
    key: SCANNER_DEVICE_TYPE,
    text: Strings.SCANNER_NAME,
    value: SCANNER_DEVICE_TYPE
  }
];

var liveListDeviceTypeMap = {};

export class GraphicTopology extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      devices: [],
      devicesInterfaceCounter: [],
      isAddDeviceModalOpen: false,
      isEditLiveListDeviceModalOpen: false,
      isDeletePositioningModalOpen: false,
      deviceType: "",
      savedDevices: [],
      connections: [],
      formInput: "",
    };
  }

  // If the network contains a duplicated IP return true, otherwise return false  
  doesNetworkContainDuplicateIP = () => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].isDuplicated === true) {
        return true;
      }
    }
    return false;
  };

  snapToGrid = (value) => Math.round(value / GRID_SIZE) * GRID_SIZE;

  snapAllNodesToGrid = () => {
    if (!network) return;

    network.storePositions();

    const updates = [];
    nodes.forEach((node) => {
      updates.push({
        id: node.id,
        x: this.snapToGrid(node.x),
        y: this.snapToGrid(node.y)
      });
    });

    if (updates.length > 0) {
      nodes.update(updates);
    }
  };

  // --- Fetching -----
  retrieveData = () => {
    this.showLoading();
    // Retrieve the live list information
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data.sort(UtilsInstance.sortBy(
          "address",
          false,
          parseInt))
      }, () => {
        // Then try to retrieve saved devices information
        fetch(Constants.REQUEST_IP_ADDRESS + "savedDevices", { mode: "cors" })
          .then(res => res.json())
          .then(data => this.setState({ savedDevices: data }, () => {
            // Finally try to retrieve saved connections information
            fetch(Constants.REQUEST_IP_ADDRESS + "savedConnections", { mode: "cors" })
              .then(res => res.json())
              .then(data => this.setState({ connections: data }, () => {
              
                fetch(Constants.REQUEST_IP_ADDRESS + "interfaceCounters", { mode: "cors" })
                  .then(res => res.json())
                  .then(data => this.setState({ devicesInterfaceCounter: data.sort((a, b) => {
                    const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
                    const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
                    return num1 - num2;
                  })}, () => {
                    if (this.doesNetworkContainDuplicateIP()) {
                      alert(Strings.DUPLICATE_IPS);
                      this.hideLoading();
                    } else {
                    
                      // If we couldn't retrieve saved information, we just load information from the live list
                      if (this.state.savedDevices.length === 0 && this.state.connections.length === 0) {
                        this.createLiveListDeviceTypeMap(false);
                        this.createNodes(false);
                        this.createNetwork(true);
                      }
                      else {
                        this.createLiveListDeviceTypeMap(true);
                        this.createNodes(true);
                        this.createConnections();

                        // If there were any devices with problems, remove them and their connections from the database
                        if (devicesToDeleteFromSavedDevices.devicesToDelete.length > 0) {

                          let deviceListAlert = Strings.POSITIONING_CONFLICT_1;

                          for (let i = 0; i < devicesToDeleteFromSavedDevices.devicesToDelete.length; i++) {
                            if (i === (devicesToDeleteFromSavedDevices.devicesToDelete.length - 1)) {
                              deviceListAlert = deviceListAlert.concat(" " + devicesToDeleteFromSavedDevices.devicesToDelete[i].id + ".");
                            }
                            else {
                              deviceListAlert = deviceListAlert.concat(" " + devicesToDeleteFromSavedDevices.devicesToDelete[i].id + ",");
                            }
                          }

                          deviceListAlert = deviceListAlert.concat(Strings.POSITIONING_CONFLICT_2);

                          alert(deviceListAlert);

                          this.removeDevicesWithProblemsFromSavedDevicesAndConnections();
                        }
                        else {
                          this.createNetwork(false);
                        }
                      }
                    }
                  }));
              }));
          }));
      }));
  }

  refreshLiveListAndScopeDeviceStatus = () => {

    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data.sort(UtilsInstance.sortBy(
          "address",
          false,
          parseInt))
      }, () => {
        // Try to update all node images, title and label based on the new live list status info.
        nodes.forEach(async (node) => {
          // If the node is a TS Scope, get the node title information
          if (typeof (node.id) === "string" && UtilsInstance.validateIPAddress(node.id)) {
            for (let i = 0; i < this.state.devices.length; i++) {
              if (node.id.toString() === this.state.devices[i].ip.toString()) {

                if (this.state.devices[i].protocol === "EtherNet/IP" && this.state.devices[i].ip !== Constants.ZERO_IP) {

                  let deviceIC = this.getDeviceFromInterfaceCounter(this.state.devices[i].ip);
                  let deviceICError = this.getIncrementErrorDevice(deviceIC);
                  let imagenPath;

                  if (deviceIC !== "") {
                    if (deviceICError) {
                      imagenPath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(liveListDeviceTypeMap[node.id].devType, this.state.devices[i], node.label, true);
                    } else {
                      imagenPath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(liveListDeviceTypeMap[node.id].devType, this.state.devices[i], node.label, false);
                    }
                  } else {
                    imagenPath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(liveListDeviceTypeMap[node.id].devType, this.state.devices[i], node.label, false);
                  }

                  nodes.update({
                    id: node.id,
                    label: node.label,
                    image: imagenPath,
                    title: this.createNodeTitle(this.state.devices[i])
                  });
                  break;
                }
              }
            }
          }
        });

        // If a new node has been found, add it 
        for (let i = 0; i < this.state.devices.length; i++) {

          if (this.state.devices[i].protocol === "EtherNet/IP" &&
          this.state.devices[i].ip !== Constants.ZERO_IP &&
          nodes.get(this.state.devices[i].ip) === null) {
            let deviceIC =  this.getDeviceFromInterfaceCounter(this.state.devices[i].ip);
            let deviceICError = this.getIncrementErrorDevice(deviceIC);
            let imagePath;

            if (deviceIC !== "") {
              if (deviceICError) {
                imagePath = this.getDeviceImagePath(this.state.devices[i], true);
              } else {
                imagePath = this.getDeviceImagePath(this.state.devices[i], false);
              }
            } else {
              imagePath = this.getDeviceImagePath(this.state.devices[i], false);
            }

            nodes.add({
              id: this.state.devices[i].ip,
              label: this.state.devices[i].ip,
              shape: "image",
              image: imagePath,
              shapeProperties: {
                useImageSize: false
              },
              title: this.createNodeTitle(this.state.devices[i])
            });

            this.addDeviceTypeToMap(this.state.devices[i]);
          }
        }
      }));
  }

  // ----------------- Device Type Map functions -----------------
  createLiveListDeviceTypeMap = (isPositionSaved) => {
    if (!isPositionSaved) {
      for (let i = 0; i < this.state.devices.length; i++) {
        liveListDeviceTypeMap[this.state.devices[i].ip] = {
          devType: this.getDeviceTypeFromLiveListStatus()
        };
      }
    }
    else {
      for (let i = 0; i < this.state.savedDevices.length; i++) {
        liveListDeviceTypeMap[this.state.savedDevices[i].id] = {
          devType: this.state.savedDevices[i].deviceType
        };
      }
    }
  }

  addDeviceTypeToMap = (device) => {
    liveListDeviceTypeMap[device.ip] = {
      devType: this.getDeviceTypeFromLiveListStatus()
    };
  }

  updateLiveListDeviceTypeMap = (deviceAddress, deviceType) => {
    // Save the choosen device type to the map
    liveListDeviceTypeMap[deviceAddress] = {
      devType: deviceType
    };
  }

  getDeviceTypeFromLiveListStatus = () => {
    return DEVICE_TYPE;
  }

  // ----------------- Network manipulation ----------------
  createNodeTitle = (device) => {
    let name = "";
    let nodeTitle = "";

    if (device.name !== null) {
      name = device.name;
    }

    nodeTitle = "<p style='text-align: justify;'> " + Strings.DEVICE_NAME_LABEL + name
      + "</p >";

    return nodeTitle;
  };

  createNodes = (isPositionSaved) => {
    nodes = new DataSet();

    if (!isPositionSaved) {
      for (let i = 0; i < this.state.devices.length; i++) {
        if (this.state.devices[i].protocol === "EtherNet/IP" && this.state.devices[i].ip !== Constants.ZERO_IP) {
          let imagePath;
          let deviceIC = this.getDeviceFromInterfaceCounter(this.state.devices[i].ip);
          let deviceICError = this.getIncrementErrorDevice(deviceIC);

          if (deviceIC !== "") {
            if (deviceICError) {
              imagePath = this.getDeviceImagePath(this.state.devices[i], true);
            } else {
              imagePath = this.getDeviceImagePath(this.state.devices[i], false);
            }
          } else {
            imagePath = this.getDeviceImagePath(this.state.devices[i], false);
          }

          nodes.add({
            id: this.state.devices[i].ip,
            label: this.state.devices[i].ip,
            shape: "image",
            image: imagePath,
            shapeProperties: {
              useImageSize: false
            },
            title: this.createNodeTitle(this.state.devices[i])
          });
        }
      }
    }
    else {
      for (let i = 0; i < this.state.savedDevices.length; i++) {

        let deviceStatus = this.getDeviceStatus(this.state.savedDevices[i].id);
        let device = this.getDeviceFromLiveList(this.state.savedDevices[i].id);
        let deviceIC = this.getDeviceFromInterfaceCounter(this.state.savedDevices[i].id);
        let deviceICError = this.getIncrementErrorDevice(deviceIC);
        let deviceImage = "";

        if (deviceStatus !== "") {
          if (deviceIC !== "") {
            if (deviceICError) {
              deviceImage = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(
                this.state.savedDevices[i].deviceType,
                device,
                this.state.savedDevices[i].label,
                true);
            } else {
              deviceImage = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(
                this.state.savedDevices[i].deviceType,
                device,
                this.state.savedDevices[i].label,
                false);
            }
          } else {
            deviceImage = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(
              this.state.savedDevices[i].deviceType,
              device,
              this.state.savedDevices[i].label,
              false);
          }
        }
        else {
          deviceImage = this.getDeviceImagePathBasedOnDeviceType(
            this.state.savedDevices[i].deviceType);
        }

        // If an image could not be found for this device, we need to remove it from 
        // the saved devices because it most likely is not the same device anymore
        if (deviceImage === undefined) {
          devicesToDeleteFromSavedDevices.devicesToDelete.push({
            "id": this.state.savedDevices[i].id
          });
        }
        else {
          if (device !== "" && device.protocol === "EtherNet/IP" && device.ip !== Constants.ZERO_IP) {

            nodes.add({
              id: this.state.savedDevices[i].id,
              label: this.state.savedDevices[i].id,
              shape: "image",
              image: deviceImage,
              shapeProperties: {
                useImageSize: false
              },
              x: this.snapToGrid(this.state.savedDevices[i].x),
              y: this.snapToGrid(this.state.savedDevices[i].y),
              title: this.createNodeTitle(device)
            });
          }
          else {
            if (this.state.savedDevices[i].label === SWITCH_DEVICE_TYPE || this.state.savedDevices[i].label === ACCESS_POINT_DEVICE_TYPE) {
              nodes.add({
                id: this.state.savedDevices[i].id,
                label: this.state.savedDevices[i].label,
                shape: "image",
                image: deviceImage,
                shapeProperties: {
                  useImageSize: false
                },
                x: this.snapToGrid(this.state.savedDevices[i].x),
                y: this.snapToGrid(this.state.savedDevices[i].y)
              });
            }
          }
        }
      }
    }
  }

  createConnections = () => {
    edges = new DataSet();

    for (let i = 0; i < this.state.connections.length; i++) {

      // Check if the devices with problems have connections. If they do save the connections to be deleted
      for (let j = 0; j < devicesToDeleteFromSavedDevices.devicesToDelete.length; j++) {

        if (this.state.connections[i].from === devicesToDeleteFromSavedDevices.devicesToDelete[j].id
          || this.state.connections[i].to === devicesToDeleteFromSavedDevices.devicesToDelete[j].id) {

          connectionsToDeleteFromSavedConnections.connectionsToDelete.push({
            "from": this.state.connections[i].from,
            "to": this.state.connections[i].to
          });

        }
      }

      edges.add({
        from: this.state.connections[i].from,
        to: this.state.connections[i].to,
        color: {
          color: this.state.connections[i].color,
          highlight: this.state.connections[i].color,
          hover: this.state.connections[i].color,
          inherit: "from",
          opacity: 1.0
        },
        width: 2.0
      });
    }
  }

  createNetwork = (isPhysicsOn) => {
    let container = document.getElementById(NETWORK_ID);

    let data = {
      nodes: nodes,
      edges: edges
    };

    let locales = {
      pt_br: {
        edit: Strings.LOCALE_EDIT,
        del: Strings.LOCALE_DEL,
        back: Strings.LOCALE_BACK,
        addNode: Strings.LOCALE_ADD_NODE,
        addEdge: Strings.LOCALE_ADD_EDGE,
        editNode: Strings.LOCALE_EDIT_NODE,
        editEdge: Strings.LOCALE_EDIT_EDGE,
        addDescription: Strings.LOCALE_ADD_DESCRIPTION,
        edgeDescription: Strings.LOCALE_EDGE_DESCRIPTION,
        editEdgeDescription: Strings.LOCALE_EDIT_EDGE_DESCRIPTION,
        createEdgeError: Strings.LOCALE_CREATE_EDGE_ERROR,
        deleteClusterError: Strings.LOCALE_DELETE_CLUSTER_ERROR,
        editClusterError: Strings.LOCALE_EDIT_CLUSTER_ERROR
      }
    };

    networkOptions = {
      autoResize: true,
      height: "100%",
      width: "100%",
      locale: "pt_br",
      locales: locales,
      interaction: {
        hover: true
      },
      edges: {
        smooth: false
      },
      physics: {
        enabled: isPhysicsOn,
        stabilization: isPhysicsOn
      },
      layout: {
        improvedLayout: false
      },
      manipulation: {
        enabled: true,
        initiallyActive: true,
        addNode: (data, callback) => {
          // Reset the device type then open the modal
          this.setState({ deviceType: "" }, () => {
            this.setState({ isAddDeviceModalOpen: true });
          });
          document.getElementById(ADD_DEVICE_MODAL_CLOSE_ID).onclick = () => {
            this.closeAddDeviceModal();
          };
          document.getElementById(ADD_DEVICE_MODAL_OK_ID).onclick = () => {
            this.addDevice(data, callback);
          };
        },
        addEdge: (edgeData, callback) => {
          edgeData.color = {
            color: DEFAULT_EDGE_COLOR,
            highlight: DEFAULT_EDGE_COLOR,
            hover: DEFAULT_EDGE_COLOR,
            inherit: "from",
            opacity: 1.0
          };
          edgeData.width = DEFAULT_EDGE_WIDTH;

          callback(edgeData); // adiciona a aresta direto, sem modal
        },
        editNode: (nodeData, callback) => {
          // Reset the device type then open the modal
          this.setState({ deviceType: "" }, () => {
            this.setState({ isEditLiveListDeviceModalOpen: true });
          });
          document.getElementById(EDIT_LL_DEVICE_MODAL_CLOSE_ID).onclick = () => {
            this.closeEditLiveListDeviceModal();
            callback(nodeData);
          };
          document.getElementById(EDIT_LL_DEVICE_MODAL_OK_ID).onclick = () => {
            this.editLiveListDevice(nodeData, callback);
          };
        },
        editEdge: true,
        deleteNode: (data, callback) => {
          let canDelete = true;
          // Search for the node in the live list, if it's there we can't delete it
          for (let i = 0; i < this.state.devices.length; i++) {
            if (data.nodes[0].toString() === this.state.devices[i].ip.toString()) {

              if (this.state.devices[i].protocol === "EtherNet/IP") {
                canDelete = false;
                break;
              } else {
                canDelete = true;
                break;
              }
            }
          }

          // If it's not in the live list that means the node is 
          // not part of the network anymore, so we can safely delete it
          if (canDelete) {
            callback(data);
          }
          else {
            alert(Strings.ALERT_NOT_POSSIBLE_TO_DELETE);
            callback(null);
          }
        },
        deleteEdge: true,
      }
    };

    network = new Network(container, data, networkOptions);

    network.on("dragEnd", (params) => {
      if (!params.nodes || params.nodes.length === 0) return;

      network.storePositions();

      const updates = params.nodes.map((id) => {
        const node = nodes.get(id);
        return {
          id,
          x: this.snapToGrid(node.x),
          y: this.snapToGrid(node.y)
        };
      });

      nodes.update(updates);
    });

    network.on("afterDrawing", () => {
    });
  }

  setNetworkOptions = (isPhysicsOn) => {
    let locales = {
      pt_br: {
        edit: Strings.LOCALE_EDIT,
        del: Strings.LOCALE_DEL,
        back: Strings.LOCALE_BACK,
        addNode: Strings.LOCALE_ADD_NODE,
        addEdge: Strings.LOCALE_ADD_EDGE,
        editNode: Strings.LOCALE_EDIT_NODE,
        editEdge: Strings.LOCALE_EDIT_EDGE,
        addDescription: Strings.LOCALE_ADD_DESCRIPTION,
        edgeDescription: Strings.LOCALE_EDGE_DESCRIPTION,
        editEdgeDescription: Strings.LOCALE_EDIT_EDGE_DESCRIPTION,
        createEdgeError: Strings.LOCALE_CREATE_EDGE_ERROR,
        deleteClusterError: Strings.LOCALE_DELETE_CLUSTER_ERROR,
        editClusterError: Strings.LOCALE_EDIT_CLUSTER_ERROR
      }
    };

    network.setOptions(
      {
        autoResize: true,
        height: "100%",
        width: "100%",
        locale: "pt_br",
        locales: locales,
        interaction: {
          hover: true
        },
        edges: {
          smooth: false
        },
        physics: {
          enabled: isPhysicsOn,
          stabilization: isPhysicsOn
        },
        layout: {
          improvedLayout: false
        },
        manipulation: {
          enabled: true,
          initiallyActive: true,
          addNode: (data, callback) => {
            // Reset the device type then open the modal
            this.setState({ deviceType: "" }, () => {
              this.setState({ isAddDeviceModalOpen: true });
            });
            document.getElementById(ADD_DEVICE_MODAL_CLOSE_ID).onclick = () => {
              this.closeAddDeviceModal();
            };
            document.getElementById(ADD_DEVICE_MODAL_OK_ID).onclick = () => {
              this.addDevice(data, callback);
            };
          },
          addEdge: (edgeData, callback) => {
            edgeData.color = {
              color: DEFAULT_EDGE_COLOR,
              highlight: DEFAULT_EDGE_COLOR,
              hover: DEFAULT_EDGE_COLOR,
              inherit: "from",
              opacity: 1.0
            };
            edgeData.width = DEFAULT_EDGE_WIDTH;

            callback(edgeData); // adiciona a aresta direto, sem modal
          },
          editNode: (nodeData, callback) => {
            // Reset the device type then open the modal
            this.setState({ deviceType: "" }, () => {
              this.setState({ isEditLiveListDeviceModalOpen: true });
            });
            document.getElementById(EDIT_LL_DEVICE_MODAL_CLOSE_ID).onclick = () => {
              this.closeEditLiveListDeviceModal();
              callback(nodeData);
            };
            document.getElementById(EDIT_LL_DEVICE_MODAL_OK_ID).onclick = () => {
              this.editLiveListDevice(nodeData, callback);
            };
          },
          editEdge: true,
          deleteNode: (data, callback) => {
            let canDelete = true;
            // Search for the node in the live list, if it's there we can't delete it
            for (let i = 0; i < this.state.devices.length; i++) {
              if (data.nodes[0].toString() === this.state.devices[i].ip.toString()) {

                if (this.state.devices[i].protocol === "EtherNet/IP") {
                  canDelete = false;
                  break;
                } else {
                  canDelete = true;
                  break;
                }
              }
            }

            // If it's not in the live list that means the node is 
            // not part of the network anymore, so we can safely delete it
            if (canDelete) {
              callback(data);
            }
            else {
              alert(Strings.ALERT_NOT_POSSIBLE_TO_DELETE);
              callback(null);
            }
          },
          deleteEdge: true,
        }
      }
    );
  }

  getDeviceStatus = (id) => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].ip.toString() === id.toString()) {
        return this.state.devices[i].status;
      }
    }
    return "";
  }

  getDeviceFromLiveList = (id) => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].ip.toString() === id.toString()) {
        return this.state.devices[i];
      }
    }
    return "";
  }

  getDeviceFromInterfaceCounter = (id) => {
    for (let i = 0; i < this.state.devicesInterfaceCounter.length; i++) {
      if (this.state.devicesInterfaceCounter[i].ip.toString() === id.toString()) {
        return this.state.devicesInterfaceCounter[i];
      }
    }
    return "";
  }

  getIncrementErrorDevice = (deviceIC) => {
    if (deviceIC !== "") {
      for (let j = 0; j < deviceIC.instances.length; j++) {
        if ((deviceIC.instances[j].in_discards_delta !== "" && parseInt(deviceIC.instances[j].in_discards_delta) > 0)
          || (deviceIC.instances[j].in_errors_delta !== "" && parseInt(deviceIC.instances[j].in_errors_delta) > 0)
          || (deviceIC.instances[j].in_unknown_protos_delta !== "" && parseInt(deviceIC.instances[j].in_unknown_protos_delta) > 0)
          || (deviceIC.instances[j].out_discards_delta !== "" && parseInt(deviceIC.instances[j].out_discards_delta) > 0)
          || (deviceIC.instances[j].out_errors_delta !== "" && parseInt(deviceIC.instances[j].out_errors_delta) > 0)
        ) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  // Returns the image path corresponding to the device status
  getDeviceImagePath = (device, incrementError) => {

    if (device.status === Constants.OK && incrementError === false) {
      return Constants.DEVICE_OK_IMG_PATH;
    }
    else if (device.status === Constants.OK && incrementError === true) {
      return Constants.DEVICE_OK_INCREMENT_ERROR_IMG_PATH;
    }
    else if (device.status === Constants.ONLINE && incrementError === false) {
      return Constants.DEVICE_OK_IMG_PATH;
    }
    else if (device.status === Constants.ONLINE && incrementError === true) {
      return Constants.DEVICE_OK_INCREMENT_ERROR_IMG_PATH;
    }
    else if (device.status === Constants.FAULT && incrementError === false) {
      return Constants.DEVICE_FAULT_IMG_PATH;
    }
    else if (device.status === Constants.FAULT && incrementError === true) {
      return Constants.DEVICE_FAULT_INCREMENT_ERROR_IMG_PATH;
    }
    else {
      return Constants.DEVICE_OK_IMG_PATH;
    }
  }

  // Returns the image path corresponding to a device type
  getDeviceImagePathBasedOnDeviceType = (deviceType) => {
    if (deviceType === SCANNER_DEVICE_TYPE) {
      return Constants.SCANNER_OK_IMG_PATH;
    }
    else if (deviceType === DEVICE_TYPE) {
      return Constants.DEVICE_OK_IMG_PATH;
    }
    else if (deviceType === SWITCH_DEVICE_TYPE) {
      return Constants.SWITCH_IMG_PATH;
    }
    else if (deviceType === DRIVE_DEVICE_TYPE) {
      return Constants.DRIVE_OK_IMG_PATH;
    }
    else if (deviceType === ACCESS_POINT_DEVICE_TYPE) {
      return Constants.ACCESS_POINT_IMG_PATH;
    }
    else {
      return Constants.DEVICE_OK_IMG_PATH;
    }
  }

  // Returns the device type corresponding to a image path
  getDeviceTypeBasedOnDeviceImagePath = (path) => {
    if (path === Constants.SCANNER_OK_IMG_PATH
      || path === Constants.SCANNER_FAULT_IMG_PATH
      || path === Constants.SCANNER_OK_INCREMENT_ERROR_IMG_PATH
      || path === Constants.SCANNER_FAULT_INCREMENT_ERROR_IMG_PATH) {
      return SCANNER_DEVICE_TYPE;
    }
    else if (path === Constants.DEVICE_OK_IMG_PATH
      || path === Constants.DEVICE_FAULT_IMG_PATH
      || path === Constants.DEVICE_OK_INCREMENT_ERROR_IMG_PATH
      || path === Constants.DEVICE_FAULT_INCREMENT_ERROR_IMG_PATH) {
      return DEVICE_TYPE;
    }
    else if (path === Constants.SWITCH_IMG_PATH
    || path === Constants.SWITCH_OK_IMG_PATH
    || path === Constants.SWITCH_FAULT_IMG_PATH
    || path === Constants.SWITCH_INCREMENT_ERROR_IMG_PATH
    || path === Constants.SWITCH_OK_INCREMENT_ERROR_IMG_PATH
    || path === Constants.SWITCH_FAULT_INCREMENT_ERROR_IMG_PATH) {
      return SWITCH_DEVICE_TYPE;
    }
    else if (path === Constants.DRIVE_OK_IMG_PATH
      || path === Constants.DRIVE_FAULT_IMG_PATH
      || path === Constants.DRIVE_OK_INCREMENT_ERROR_IMG_PATH
      || path === Constants.DRIVE_FAULT_INCREMENT_ERROR_IMG_PATH) {
      return DRIVE_DEVICE_TYPE;
    }
    else if (path === Constants.ACCESS_POINT_IMG_PATH) {
      return ACCESS_POINT_DEVICE_TYPE;
    }
    else {
      return DEVICE_TYPE;
    }
  }

  getDeviceImagePathBasedOnDeviceTypeAndStatus = (deviceType, device, label, incrementError) => {
    if (deviceType === SCANNER_DEVICE_TYPE) {
      if (device.status === Constants.OK && incrementError === false) {
        return Constants.SCANNER_OK_IMG_PATH;
      }
      else if (device.status === Constants.OK && incrementError === true) {
        return Constants.SCANNER_OK_INCREMENT_ERROR_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === false) {
        return Constants.SCANNER_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === true) {
        return Constants.SCANNER_FAULT_INCREMENT_ERROR_IMG_PATH;
      } 
      else {
        return Constants.SCANNER_OK_IMG_PATH;
      }
    }
    else if (deviceType === DEVICE_TYPE) {
      if (device.status === Constants.OK && incrementError === false) {
        return Constants.DEVICE_OK_IMG_PATH;
      }
      else if (device.status === Constants.OK && incrementError === true) {
        return Constants.DEVICE_OK_INCREMENT_ERROR_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === false) {
        return Constants.DEVICE_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === true) {
        return Constants.DEVICE_FAULT_INCREMENT_ERROR_IMG_PATH;
      } 
      else {
        return Constants.DEVICE_OK_IMG_PATH;
      }
    }
    else if (deviceType === DRIVE_DEVICE_TYPE) {
      if (device.status === Constants.OK && incrementError === false) {
        return Constants.DRIVE_OK_IMG_PATH;
      }
      else if (device.status === Constants.OK && incrementError === true) {
        return Constants.DRIVE_OK_INCREMENT_ERROR_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === false) {
        return Constants.DRIVE_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === true) {
        return Constants.DRIVE_FAULT_INCREMENT_ERROR_IMG_PATH;
      }
      else {
        return Constants.DRIVE_OK_IMG_PATH;
      }
    }
    else if (deviceType === SWITCH_DEVICE_TYPE) {
      if (device.status === Constants.OK && incrementError === false) {
        return Constants.SWITCH_OK_IMG_PATH;
      }
      else if (device.status === Constants.OK && incrementError === true) {
        return Constants.SWITCH_OK_INCREMENT_ERROR_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === false) {
        return Constants.SWITCH_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.FAULT && incrementError === true) {
        return Constants.SWITCH_FAULT_INCREMENT_ERROR_IMG_PATH;
      }
      else if (label !== SWITCH_DEVICE_TYPE && incrementError === false) {
        return Constants.SWITCH_OK_IMG_PATH;
      }
      else if (label !== SWITCH_DEVICE_TYPE && incrementError === true) {
        return Constants.SWITCH_INCREMENT_ERROR_IMG_PATH;
      }
      else {
        return Constants.SWITCH_IMG_PATH;
      }
    }
    else if (deviceType === ACCESS_POINT_DEVICE_TYPE) {
      return Constants.ACCESS_POINT_IMG_PATH;
    }
    else {
      return Constants.DEVICE_OK_IMG_PATH;
    }
  }

  // ----------------- Device manipulation ----------------
  closeAddDeviceModal = () => {
    this.setState({
      isAddDeviceModalOpen: false,
    });
  }

  closeEditLiveListDeviceModal = () => {
    this.setState({ isEditLiveListDeviceModalOpen: false });
  }

  addDevice = async (data, callback) => {
    if (this.state.deviceType === "") {
      alert(Strings.ALERT_CHOOSE_DEVICE_TYPE);
    } 
    else {
      let imagePath = this.getDeviceImagePathBasedOnDeviceType(this.state.deviceType);

      data.label = this.state.deviceType;
      data.shape = "image";
      data.image = imagePath;
      data.shapeProperties = {
        useImageSize: false
      };
      data.x = this.snapToGrid(data.x);
      data.y = this.snapToGrid(data.y);
      this.setState({
        isAddDeviceModalOpen: false,
      });
      callback(data);
    }
  }

  editLiveListDevice = (nodeData, callback) => {
    // Only let the user press the edit button if he did choose a device type
    if (this.state.deviceType === "") {
      alert(Strings.ALERT_CHOOSE_DEVICE_TYPE);
    }
    else {
      
      let device = this.getDeviceFromLiveList(nodeData.id);
      

      if (device !== "" && device.protocol ===  "EtherNet/IP") {
        // Device
        let deviceIC =  this.getDeviceFromInterfaceCounter(nodeData.id);
        let deviceICError = this.getIncrementErrorDevice(deviceIC);
        let deviceStatus = this.getDeviceStatus(nodeData.id);
        let imagePath;

        if (deviceIC !== "") {
          if (deviceICError) {
            imagePath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(this.state.deviceType, device, nodeData.label, true);
          } else {
            imagePath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(this.state.deviceType, device, nodeData.label, false);
          }
        } else {
          imagePath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(this.state.deviceType, device, nodeData.label, false);
        }
        
        // Save the choosen device type to the map
        this.updateLiveListDeviceTypeMap(nodeData.id, this.state.deviceType);

        liveListDeviceTypeMap[nodeData.id] = {
          status: deviceStatus,
          devType: this.state.deviceType
        };

        // Then change the image
        nodeData.shape = "image";
        nodeData.image = imagePath;
        nodeData.shapeProperties = {
          useImageSize: false
        };

        this.setState({ isEditLiveListDeviceModalOpen: false });
        callback(nodeData);
      } else {
        alert(Strings.ALERT_CHOOSE_DEVICE_TYPE_ERROR);
      }
    }
  }

  onTypeDropdownChange = (e, { value }) => {
    this.setState({ deviceType: value });
  }

  onTypeDropdownChange = (e, { value }) => {
    this.setState({ deviceType: value }, () => {
      let IdElements = document.getElementsByClassName(ADD_IP_ID);

      for (let i = 0; i < IdElements.length; i++) {
        IdElements[i].style.display = "flex";
      }

    });
  }

  // ----------------- Right sidebar buttons -----------------

  // Pauses the network physics so the user can manually adjust the nodes positioning
  handleEditNodesPositionClick = () => {
    this.setNetworkOptions(false);
  }

  // Saves the position of each of the nodes so we can position them
  // on the same place when refreshing the page
  handleSaveNodesPositionClick = () => {
    this.snapAllNodesToGrid();

    let networkInformation = {
      devices: []
    };

    let connectivityInformation = {
      edges: []
    };

    nodes.forEach((node) => {
      let nodeInfo = {
        "id": node.id,
        "label": node.label,
        "x": node.x,
        "y": node.y,
        "deviceType": this.getDeviceTypeBasedOnDeviceImagePath(node.image)
      };
      networkInformation.devices.push(nodeInfo);
    });

    edges.forEach((edge) => {
      let edgeInfo = {
        "from": edge.from,
        "to": edge.to,
        "color": edge.color.color
      };
      connectivityInformation.edges.push(edgeInfo);
    });

    let networkData = JSON.stringify(networkInformation);
    let connectivityData = JSON.stringify(connectivityInformation);

    // Try to save the nodes of the network
    fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyNetworkSave_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: networkData
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        // Then try to save the connections
        fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyConnectivitySave_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: connectivityData
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.SAVE_TOPOLOGY_POS_SUCCESS_STRING);
            this.setNetworkOptions(false);
          })
          .catch((error) => {
            alert(Strings.SAVE_TOPOLOGY_POS_FAILURE_STRING + error);
          });
      })
      .catch((error) => {
        alert(Strings.SAVE_TOPOLOGY_POS_FAILURE_STRING + error);
      });
  }

  handleDeleteNodesPositionClick = () => {
    this.setState({ isDeletePositioningModalOpen: true });
  }

  handleDeleteNodesPositionModalPositiveClick = () => {
    this.setState({ isDeletePositioningModalOpen: false });

    let data = JSON.stringify({
      reset: "True"
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "graphicTopologyDrop_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.DROP_TOPOLOGY_POS_SUCCESS_STRING);
        this.setNetworkOptions(true);
        edges = new DataSet();
        this.retrieveData();
      })
      .catch((error) => {
        alert(Strings.DROP_TOPOLOGY_POS_FAILURE_STRING + error);
      });
  }

  handleDeleteNodesPositionModalNegativeClick = () => {
    this.setState({ isDeletePositioningModalOpen: false });
  }

  // ----------------- Image Export -----------------
  exportSvg = () => {
    let networkContainer = network.body.container;
    let ctx = new C2S({ width: networkContainer.clientWidth, height: networkContainer.clientWidth, enableMirroring: true });

    let canvasProto = network.canvas.__proto__;
    let currentGetContext = canvasProto.getContext;
    canvasProto.getContext = function () {
      return ctx;
    };
    let svgOptions = {
      nodes: {
        shapeProperties: {
          interpolation: false //so images are not scaled svg will get full image
        },
        scaling: { label: { drawThreshold: 0 } }
      },
      edges: {
        scaling: { label: { drawThreshold: 0 } }
      }
    };
    network.setOptions(svgOptions);
    canvasProto.getContext = currentGetContext;
    setTimeout(() => {
      let svg = ctx.getSerializedSvg();
      this.showSvg(svg);
    }, 1000);
  }

  showSvg = (svg) => {
    let svgBlob = new Blob([svg], { type: "image/svg+xml" });
    this.openBlob(svgBlob, "network.svg");
  }

  openBlob = (blob, fileName) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {

      //blobToDataURL(blob, function(dataurl){window.open(dataurl);});
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
      let a = document.getElementById("blobLink");
      if (!a) {
        a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("id", "blobLink");
        a.style = "display: none";
      }
      let data = window.URL.createObjectURL(blob);
      a.href = data;
      a.download = fileName;
      a.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    }
  }

  // ----------------- Remove Problematic Devices -----------------
  removeDevicesWithProblemsFromSavedDevicesAndConnections = () => {
    let networkData = JSON.stringify(devicesToDeleteFromSavedDevices);
    let connectivityData = JSON.stringify(connectionsToDeleteFromSavedConnections);

    // Try to remove the devices from saved devices
    fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyNodesDelete_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: networkData
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        // Then try to remove the connections that these devices had
        fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyConnectivityDelete_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: connectivityData
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS);

            // Reset the list of devices and connections with problems
            devicesToDeleteFromSavedDevices = { devicesToDelete: [] };
            connectionsToDeleteFromSavedConnections = { connectionsToDelete: [] };

            // and get the topology data again
            this.retrieveData();

          })
          .catch((error) => {
            alert(Strings.POSITIONING_ANG_CONNECTIONS_RESET_FAILURE + error);
          });
      })
      .catch((error) => {
        alert(Strings.POSITIONING_ANG_CONNECTIONS_RESET_FAILURE + error);
      });
  }

  // ----------------- Topology Import / Export -----------------
  exportTopology = () => {
    if (network !== undefined && network !== null) {
      this.snapAllNodesToGrid();

      let topologyInfo = {
        devices: [],
        edges: []
      };

      // Add the position and image type of each device
      nodes.forEach((node) => {
        let nodeInfo = {
          "id": node.id,
          "label": node.label,
          "x": node.x,
          "y": node.y,
          "deviceType": this.getDeviceTypeBasedOnDeviceImagePath(node.image)
        };
        topologyInfo.devices.push(nodeInfo);
      });
      // Add the connections
      edges.forEach((edge) => {
        let edgeInfo = {
          "from": edge.from,
          "to": edge.to,
          "color": edge.color.color
        };
        topologyInfo.edges.push(edgeInfo);
      });

      let topologyJSONInfo = JSON.stringify(topologyInfo);

      let dataStr = "data:application/json;charset=utf-8," + encodeURIComponent(topologyJSONInfo);
      let downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", `${Strings.EXPORT_TOPOLOGY}.json`);
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    }
  }

  importTopology = () => {
    let fileInput = document.getElementById("import-topology-input-file");

    if (fileInput.files[0] !== undefined && fileInput.files[0] !== null) {
      let file = fileInput.files[0];
      let fileReader = new FileReader();

      // Import the topology information when the file is ready to be read
      fileReader.onload = (event) => {
        try {
          let topologyJSONObject = JSON.parse(event.target.result);

          // Check if saved devices or connections are not defined
          let areDevicesOk = topologyJSONObject.devices !== undefined && topologyJSONObject.devices !== null;
          let areEdgesOk = topologyJSONObject.edges !== undefined && topologyJSONObject.edges !== null;

          if (areDevicesOk && areEdgesOk) {
            // If there are no problems, save them
            let networkData = JSON.stringify({ devices: topologyJSONObject.devices });
            let connectivityData = JSON.stringify({ edges: topologyJSONObject.edges });

            // Try to save the nodes of the network
            fetch(Constants.REQUEST_IP_ADDRESS + "graphicTopologyNetworkSave_POST", {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              },
              body: networkData
            })
              .then(UtilsInstance.checkStatus)
              .then(() => {
                // Then try to save the connections
                fetch(Constants.REQUEST_IP_ADDRESS + "graphicTopologyConnectivitySave_POST", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                  },
                  body: connectivityData
                })
                  .then(UtilsInstance.checkStatus)
                  .then(() => {
                    alert(Strings.TOPOLOGY_IMPORT_SUCCESS);
                    // If everything was ok, retrieve data to refresh the network
                    this.retrieveData();
                  })
                  .catch((error) => {
                    alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + error);
                  });
              })
              .catch((error) => {
                alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + error);
              });
          }
          else {
            alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + Strings.INVALID_OR_CORRUPT_FILE);
          }
        }
        catch (error) {
          alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + Strings.INVALID_OR_CORRUPT_FILE);
        }
      };

      fileReader.readAsText(file);
    }
    else {
      alert(Strings.PLEASE_SELECT_TOPOLOGY_FILE);
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = () => {
    sessionStorage.removeItem("auth");

    devicesToDeleteFromSavedDevices = { devicesToDelete: [] };
    connectionsToDeleteFromSavedConnections = { connectionsToDelete: [] };

    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.refreshLiveListAndScopeDeviceStatus, 5000) });
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalID);
  }

  /*
  Saves the form input to the component state everytime the user
  types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit = () => {
    // Only try to search if the user has typed a valid ip address
    if (ipRegex.test(this.state.formInput)) {
      let deviceIP = this.state.formInput;
      for (let i = 0; i < this.state.connections.length; i++) {
        if (deviceIP === this.state.connections[i].from || deviceIP === this.state.connections[i].to) {
          network.focus(deviceIP);
          network.selectNodes([deviceIP]);
          network.fit({
            nodes: [deviceIP],
            animation: true
          });
          return;
        }
      }
      alert(Strings.FORM_INPUT_NOT_FOUND_1 + deviceIP + Strings.FORM_INPUT_NOT_FOUND_2);
      return;
    }
    else {
      alert(Strings.FORM_INPUT_INVALID_IP);
    }
  };

  showLoading = () => this.setState({ isLoadingActive: true });
  hideLoading = () => this.setState({ isLoadingActive: false });

  render() {
    const filter = this.state.formInput;

    return (
      <div style={networkContainerStyle} >

        <Grid style={gridStyle} columns={3} verticalAlign="middle">

          <Grid.Column textAlign="left" width={4}>
            <Popup position='bottom left' hoverable pinned wide
              trigger={<Icon name="question circle" size="big" color="teal" fitted />}>
              <Popup.Content>
                <Divider horizontal fitted>{Strings.COLORS_LABELS}</Divider>
                <List>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#21ba45" }} />
                    {Strings.LABEL_DEVICE_OK}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#f40000" }} />
                    {Strings.LABEL_DEVICE_FAULT}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#38c7bd" }} />
                    {Strings.LABEL_NO_STATUS}
                  </List.Item>
                  <List.Item>
                    <Image src={Constants.ALERT_IMG} avatar style={{ width: 16, height: 16 }} />
                    {Strings.LABEL_DEVICE_INCREMENT_ERROR}
                  </List.Item>
                </List>
              </Popup.Content>
            </Popup >
          </Grid.Column>

          <Grid.Column width={8}>
            <Form onSubmit={this.handleSubmit} >
              <Form.Input
                id="inputform"
                placeholder={Strings.GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER}
                icon="search"
                name="formInput"
                value={filter}
                onChange={this.handleChange} />
            </Form>
          </Grid.Column>

          <Grid.Column width={4} />

        </Grid>

        <Grid divided='vertically' doubling stackable >

          <Grid.Row columns={2}>

            <Grid.Column width={12}>
              <div id={NETWORK_ID} style={networkStyle} />
            </Grid.Column>

            <Grid.Column width={4}>
              <Segment>
                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>{Strings.POSITION}</Divider>

                <Button size="small" compact fluid color="teal" onClick={this.handleEditNodesPositionClick}>{Strings.EDIT_TOPOLOGY_POS_STRING}</Button><br />
                <Button size="small" compact fluid color="teal" onClick={this.handleSaveNodesPositionClick}>{Strings.SAVE_TOPOLOGY_POS_STRING}</Button><br />
                <Button size="small" compact fluid color="teal" onClick={this.handleDeleteNodesPositionClick}>{Strings.DELETE_TOPOLOGY_POS_STRING}</Button><br />

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>{Strings.EXPORT}</Divider>

                <Button size="small" compact fluid color="teal" onClick={this.exportSvg}>{Strings.EXPORT_SVG}</Button><br />
                <Button size="small" compact fluid color="teal" onClick={this.exportTopology}>{Strings.EXPORT_TOPOLOGY}</Button><br />

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>{Strings.IMPORT_TOPOLOGY}</Divider>

                <Form onSubmit={this.importTopology}>
                  <Form.Input id="import-topology-input-file" type="file" accept=".json" />
                  <Button size="small" compact fluid color="teal" type="submit" content={Strings.IMPORT} />
                </Form>

              </Segment>

            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Modal basic size='mini' open={this.state.isAddDeviceModalOpen}>
          <Modal.Header content={Strings.ADD_DEVICE} />
          <Modal.Content>
            <Dropdown
              placeholder={Strings.DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER}
              fluid
              selection
              scrolling
              options={typeOptions}
              onChange={this.onTypeDropdownChange} /><br />

          </Modal.Content>
          <Modal.Actions>
            <Button id={ADD_DEVICE_MODAL_CLOSE_ID} color='red'>
              <Icon name='remove' />
              {Strings.CANCEL}
            </Button>
            <Button id={ADD_DEVICE_MODAL_OK_ID} color='green'>
              <Icon name='checkmark' />
              {Strings.ADD}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='mini' open={this.state.isEditLiveListDeviceModalOpen}>
          <Modal.Header content={Strings.EDIT_DEVICE} />
          <Modal.Content>
            <Dropdown
              placeholder={Strings.DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER}
              fluid
              selection
              scrolling
              options={liveListTypeOptions}
              onChange={this.onTypeDropdownChange} />
          </Modal.Content>
          <Modal.Actions>
            <Button id={EDIT_LL_DEVICE_MODAL_CLOSE_ID} color='red'>
              <Icon name='remove' />
              {Strings.CANCEL}
            </Button>
            <Button id={EDIT_LL_DEVICE_MODAL_OK_ID} color='green'>
              <Icon name='checkmark' />
              {Strings.EDIT_TOPOLOGY_POS_STRING}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='mini' open={this.state.isDeletePositioningModalOpen}>
          <Header icon='trash' content={Strings.REMOVE_POSITIONING} />
          <Modal.Content>
            <p>{Strings.ASK_REMOVE_POSITIONING}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' inverted onClick={this.handleDeleteNodesPositionModalNegativeClick}>{Strings.NO}</Button>
            <Button color='green' inverted onClick={this.handleDeleteNodesPositionModalPositiveClick}>{Strings.YES}</Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const networkStyle = {
  height: "70vh",
  border: "1px solid lightgray",
};

const gridStyle = {
  marginBottom: "-20pt"
};

const networkContainerStyle = {
  textAlign: "center",
  padding: "0 24px"  // ou 24px, etc
};

export default GraphicTopology;
